
import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Typography,
    LinearProgress,
    Button,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    IconButton,
    Checkbox,
} from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";

function ReadBrief({ newBrief, selecetedAllocation, setSelectedOptions, setIsQuizSubmitted, selectedOptions, QuizList, handleOpenQuiz, submitform, isVewOnly, handleClose, title }: any) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isQuizStarted, setIsQuizStarted] = useState(false);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [activeMenu, setActiveMenu] = useState<"brief" | "quiz">("brief");
    const [currentSection, setcurrentSection] = useState<any>()
    const [quizResult, setQuizResult] = useState<{
        passed: boolean;
        correct: number;
        total: number;
    } | null>(null);
    useEffect(() => {
        newBrief && setcurrentSection(newBrief[currentIndex])
    }, [newBrief, currentIndex])
    const [retryQuizList, setRetryQuizList] = useState<any[]>([]);
    const displayQuizList =
        retryQuizList.length > 0 ? retryQuizList : QuizList;
    // const currentSection =  newBrief[currentIndex] || {};
    // console.log("selected Options", selectedOptions)
    const nextSection = () => {
        if (currentIndex < newBrief.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
        else {
            if (isVewOnly) {
                // just close the popup
                handleClose();
                return;
            }
            // if (selecetedAllocation?.venueId?.clientEntityId?.quizBrief || selecetedAllocation?.clientEntityId?.quizBrief) {
            if (!isQuizStarted && !isVewOnly) {
                setIsQuizStarted(true);
                // setCurrentIndex(-1)
                setActiveMenu("quiz");
            } else {
                submitform();
            }
        }
    };

    const prevSection = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    // useEffect(() => {
    //     if (!isVewOnly && (selecetedAllocation?.venueId?.clientEntityId?.quizBrief || selecetedAllocation?.clientEntityId?.quizBrief)) {
    //         handleOpenQuiz((selecetedAllocation?.venueId?.clientEntityId?.clientEntityId || selecetedAllocation?.clientEntityId?.clientEntityId), selecetedAllocation?.venueId?.venueId)
    //     }
    // }, [])
    const hasOpenedQuiz = useRef(false);
    useEffect(() => {
        if (hasOpenedQuiz.current) return;

        if (
            !isVewOnly
            // &&
            // (
            //     selecetedAllocation?.venueId?.clientEntityId?.quizBrief ||
            //     selecetedAllocation?.clientEntityId?.quizBrief
            // )
        ) {
            hasOpenedQuiz.current = true;

            handleOpenQuiz(
                selecetedAllocation?.venueId?.clientEntityId?.clientEntityId ||
                selecetedAllocation?.clientEntityId?.clientEntityId,
                selecetedAllocation?.venueId?.venueId
            );
        }
    }, [isVewOnly, handleOpenQuiz, selecetedAllocation]);

    const handleClosePopup = () => {
        const isConfirm = window.confirm("Are you sure you want to quit the quiz? You will lose your filled quiz data")
        if (isConfirm) {
            handleClose()
        }
    }
    return (
        <Box className='h-100 w-100 p-2' sx={{ background: '#E3DDD1' }}>
            <Box className='d-flex h-100'>
                <Box
                    className='p-3 border-10'
                    sx={{
                        width: '25%',
                        maxWidth: "300px",
                        bgcolor: "#ADB792",
                        p: 2,
                        overflowY: "auto",
                    }}
                >
                    {/* <Typography variant="h5" className="fw-bold mb-2">
                        Mysterey
                        <br />
                        Management
                    </Typography>

                    <Typography variant="body2">Mission Brief</Typography> */}

                    {newBrief?.map((section: any, index: number) => (
                        <Box
                            key={index}
                            onClick={() => {
                                setCurrentIndex(index);
                                setActiveMenu("brief");
                                setIsQuizStarted(false)
                            }}
                            className='border-10 p-2 px-3 mb-2'
                            sx={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                bgcolor:
                                    (currentIndex === index && activeMenu === "brief")
                                        ? "#fff"
                                        : "transparent",
                            }}
                        >
                            <Box className='d-flex align-items-center gap-2'>
                                <Box className='d-flex align-items-center border-10' p={1} bgcolor={currentIndex == index ? "#000000" : "#0000001A"} height={'fit-content'}>
                                    <img src={section?.iconImage} height={'20px'} width={'20px'} alt="" />
                                </Box>
                                <Typography fontWeight={500}>
                                    {section?.title}
                                </Typography>
                            </Box>

                            <Typography color="#777">
                                {(index + 1).toString().padStart(2, "0")}
                            </Typography>
                        </Box>
                    ))}
                    {displayQuizList && !isVewOnly && (
                        <Box mt={3}>
                            <Typography
                                variant="body2"
                                sx={{
                                    color: "#555",
                                    fontWeight: 600,
                                    mb: 1,
                                }}
                            >
                                Assessment
                            </Typography>

                            <Box
                                onClick={() => {
                                    setActiveMenu("quiz");
                                    // setCurrentIndex(-1)
                                    setIsQuizStarted(true);
                                }}
                                className="border-10 p-2 px-3"
                                sx={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    bgcolor: activeMenu === "quiz" ? "#fff" : "transparent",
                                }}
                            >
                                <Typography fontWeight={500}>
                                    Knowledge Check
                                </Typography>

                                <Typography color="#777">
                                    KC
                                </Typography>
                            </Box>
                        </Box>
                    )}
                </Box>

                {/* Main */}
                <Box flex={1} className='d-flex flex-column p-3 overflow-hidden h-100 gap-3'>
                    {/* Header */}
                    <Box
                        className='py-2 border-bottom w-100'>
                        <Box className='d-flex justify-content-between'>
                            <Typography
                                variant="h4"
                                className="m-0 p-0"
                                fontWeight={600}
                            >
                                {title}
                            </Typography>
                            <IconButton onClick={() => { isVewOnly ? handleClose() : handleClosePopup() }}>
                                <CancelOutlined />
                            </IconButton>
                        </Box>

                        {activeMenu === "brief" && (
                            <Box mt={2}>
                                <Typography mb={1}>
                                    Reading {currentIndex + 1} of {newBrief?.length}
                                </Typography>
                                <LinearProgress
                                    variant="determinate"
                                    value={
                                        ((currentIndex + 1) /
                                            newBrief?.length) *
                                        100
                                    }
                                    sx={{
                                        height: 8,
                                        borderRadius: 10,
                                        backgroundColor: "#fff",
                                        "& .MuiLinearProgress-bar": {
                                            backgroundColor: "#ADB792",
                                        },
                                    }}
                                />
                            </Box>
                        )}
                        {activeMenu === "quiz" && (
                            <Box mt={2}>
                                <Typography mb={1}>
                                    Question {currentQuestionIndex + 1} of {displayQuizList?.length}
                                </Typography>
                                <LinearProgress
                                    variant="determinate"
                                    value={
                                        ((currentQuestionIndex + 1) /
                                            displayQuizList?.length) *
                                        100
                                    }
                                    sx={{
                                        height: 8,
                                        borderRadius: 10,
                                        backgroundColor: "#fff",
                                        "& .MuiLinearProgress-bar": {
                                            backgroundColor: "#ADB792",
                                        },
                                    }}
                                />
                            </Box>
                        )}
                    </Box>


                    <Box
                        className='h-100'
                        sx={{
                            width: "100%",
                            maxHeight: '100%',
                            overflowY: 'auto',
                            bgcolor: "#fff",
                            borderRadius: '20px',
                            p: 3,
                            boxShadow: "0 5px 20px rgba(0,0,0,.08)",
                        }}
                    >
                        {!isQuizStarted ? (
                            <>
                                <Box className='d-flex align-items-start gap-3'>
                                    <Box sx={{
                                        display: "flex",
                                        alignItems: 'center',
                                        gap: 2,
                                        mb: 2,
                                        bgcolor: currentSection?.toneColor,
                                        width: 'fit-content',
                                        borderRadius: "50px",
                                        px: 1.5,
                                        py: 1.5,
                                    }}>
                                        <img src={currentSection?.iconImage} height={'25px'} width={'25px'} alt="" />
                                        {/* <Box
                                        sx={{
                                            fontSize: '12px',
                                        }}
                                    >
                                        {currentSection?.iconName ?? "Caption"}
                                    </Box> */}

                                        {/* <Typography variant="body2" color="#666">
                                        Section {(currentIndex + 1)
                                            .toString()
                                            .padStart(2, "0")} / {newBrief?.length}
                                    </Typography> */}
                                    </Box>
                                    <Typography variant="h3" className="fw-medium mb-3" fontFamily={'"Instrument Serif", serif !important'}>
                                        {currentSection?.title}
                                    </Typography>
                                </Box>


                                <Box
                                    className='custom-html'
                                    dangerouslySetInnerHTML={{
                                        __html: currentSection?.description,
                                    }}
                                />
                            </>
                        ) :
                            quizResult && !quizResult.passed ? (
                                <Box
                                    className="h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                >

                                    <Box
                                        sx={{
                                            width: 50,
                                            height: 50,
                                            borderRadius: "50%",
                                            bgcolor: "#F9E8E8",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            mb: 3
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#D9534F",
                                                fontSize: 42,
                                                fontWeight: 300
                                            }}
                                        >
                                            ✕
                                        </Typography>
                                    </Box>

                                    <Typography
                                        variant="h4"
                                        className="fw-bold mb-3"
                                        sx={{ color: "#c15b5b" }}
                                    >
                                        Score {quizResult.correct} / {quizResult.total}
                                    </Typography>

                                    <Typography
                                        sx={{
                                            maxWidth: 320,
                                            color: "#444",
                                            mb: 4
                                        }}
                                    >
                                        You must answer every question correctly to apply for this task.
                                        Review your mistakes and try again.
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color: "#666",
                                            mb: 1
                                        }}
                                    >
                                        Accuracy: {Math.round((quizResult.correct / quizResult.total) * 100)}%
                                    </Typography>

                                    <LinearProgress
                                        variant="determinate"
                                        value={(quizResult.correct / quizResult.total) * 100}
                                        sx={{
                                            width: 220,
                                            height: 8,
                                            borderRadius: 10,
                                            mb: 5,
                                            backgroundColor: "#E5E2DD",
                                            "& .MuiLinearProgress-bar": {
                                                backgroundColor: "#D9534F"
                                            }
                                        }}
                                    />


                                    <Button
                                        variant="outlined"
                                        className="button-primary-outlined px-5 py-2"
                                        onClick={async () => {
                                            // await handleOpenQuiz(
                                            //     (selecetedAllocation?.venueId?.clientEntityId?.clientEntityId || selecetedAllocation?.clientEntityId?.clientEntityId),
                                            //     selecetedAllocation?.venueId?.venueId
                                            // );
                                            setIsQuizStarted(true);
                                            setQuizResult(null)
                                            setCurrentQuestionIndex(0)
                                        }}
                                    >
                                        Retake Quiz
                                    </Button>

                                </Box>
                            ) : (
                                <>
                                    {/* <Typography variant="h4" className="fw-bold mb-4">
                                        Quiz
                                    </Typography> */}

                                    {displayQuizList?.length > 0 && (
                                        <>
                                            <Box className="mb-3">

                                                <Box className="d-flex mb-3" gap={1}>
                                                    <span className="fw-bold" style={{ fontFamily: 'Instrument Serif, serif', fontSize: '32px' }}>
                                                        Q{currentQuestionIndex + 1}.
                                                    </span>

                                                    <div
                                                        className="quiz"
                                                        style={{ fontFamily: 'Instrument Serif, serif', fontSize: '32px' }}
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                displayQuizList[currentQuestionIndex]
                                                                    ?.question_text
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    dangerouslySetInnerHTML={{ __html: displayQuizList[currentQuestionIndex]
                                                                    ?.questionDescription }}
                                                />

                                                {displayQuizList[currentQuestionIndex]?.questionType === 'checkbox' ? (
                                                    <>
                                                        {/* <FormControl>
                                                            <RadioGroup
                                                                value={
                                                                    selectedOptions[currentQuestionIndex]
                                                                        ?.SelectedAnswer ?? ""
                                                                }
                                                                onChange={(e) => {
                                                                    const updatedOptions = [...selectedOptions];

                                                                    updatedOptions[currentQuestionIndex] = {
                                                                        ...updatedOptions[currentQuestionIndex],
                                                                        SelectedAnswer: parseInt(
                                                                            e.target.value
                                                                        ),
                                                                    };

                                                                    setSelectedOptions(updatedOptions);
                                                                }}
                                                            >
                                                                {JSON.parse(
                                                                    displayQuizList[currentQuestionIndex]?.options
                                                                ).map((option: any) => (
                                                                    <FormControlLabel
                                                                        key={option.option_id}
                                                                        value={parseInt(option.option_id)}
                                                                        control={<Radio />}
                                                                        label={option.option_label}
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                        </FormControl> */}
                                                        {JSON.parse(
                                                            displayQuizList[currentQuestionIndex]?.options
                                                        ).map((option: any) => {
                                                            const selectedAnswers =
                                                                selectedOptions[currentQuestionIndex]?.SelectedAnswer || [];

                                                            return (
                                                                <FormControlLabel
                                                                    key={option.option_id}
                                                                    className="d-block"
                                                                    control={
                                                                        <Checkbox
                                                                            checked={selectedAnswers.includes(Number(option.option_id))}
                                                                            onChange={(e) => {
                                                                                const updatedOptions = [...selectedOptions];

                                                                                let answers = [
                                                                                    ...(updatedOptions[currentQuestionIndex]?.SelectedAnswer ||
                                                                                        []),
                                                                                ];

                                                                                if (e.target.checked) {
                                                                                    answers.push(Number(option.option_id));
                                                                                } else {
                                                                                    answers = answers.filter(
                                                                                        (id: number) => id !== Number(option.option_id)
                                                                                    );
                                                                                }

                                                                                updatedOptions[currentQuestionIndex] = {
                                                                                    ...updatedOptions[currentQuestionIndex],
                                                                                    SelectedAnswer: answers,
                                                                                };

                                                                                setSelectedOptions(updatedOptions);
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={option.option_label}
                                                                />
                                                            );
                                                        })}
                                                    </>
                                                ) :
                                                    (
                                                        <FormControl>
                                                            <RadioGroup
                                                                value={
                                                                    selectedOptions[currentQuestionIndex]
                                                                        ?.SelectedAnswer ?? ""
                                                                }
                                                                onChange={(e) => {
                                                                    const updatedOptions = [...selectedOptions];

                                                                    updatedOptions[currentQuestionIndex] = {
                                                                        ...updatedOptions[currentQuestionIndex],
                                                                        SelectedAnswer: parseInt(
                                                                            e.target.value
                                                                        ),
                                                                    };

                                                                    setSelectedOptions(updatedOptions);
                                                                }}
                                                            >
                                                                {JSON.parse(
                                                                    displayQuizList[currentQuestionIndex]?.options
                                                                ).map((option: any) => (
                                                                    <FormControlLabel
                                                                        key={option.option_id}
                                                                        value={parseInt(option.option_id)}
                                                                        control={<Radio />}
                                                                        label={option.option_label}
                                                                    />
                                                                ))}
                                                            </RadioGroup>
                                                        </FormControl>
                                                    )}
                                            </Box>
                                        </>
                                    )}
                                </>
                            )}
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        {!isQuizStarted ? (
                            <>
                                <Button
                                    onClick={prevSection}
                                    disabled={currentIndex === 0}
                                    variant="outlined"
                                    className="button-secondary-outlined py-2 px-5"
                                >
                                    Previous
                                </Button>

                                <Button
                                    onClick={nextSection}
                                    variant="contained"
                                    className="button-primary py-2 px-5"
                                >
                                    {currentIndex + 1 === newBrief?.length
                                        ? (!isVewOnly)
                                            ? "Start Quiz"
                                            : "Finish"
                                        : "Next Section"}
                                </Button>
                            </>
                        ) :
                            !quizResult && (
                                <>
                                    <Button
                                        variant="outlined"
                                        className="button-secondary-outlined py-2 px-5"
                                        disabled={currentQuestionIndex === 0}
                                        onClick={() =>
                                            setCurrentQuestionIndex(currentQuestionIndex - 1)
                                        }
                                    >
                                        Previous
                                    </Button>

                                    {currentQuestionIndex < displayQuizList.length - 1 ? (
                                        <Button
                                            variant="contained"
                                            className="button-primary py-2 px-5"
                                            onClick={() =>
                                                setCurrentQuestionIndex(currentQuestionIndex + 1)
                                            }
                                        >
                                            Next Question
                                        </Button>
                                    ) : (
                                        <Button
                                            className="button-primary px-4 py-2"
                                            // onClick={() => {
                                            //     let correct = 0;

                                            //     selectedOptions.map((item: any) => {
                                            //         if (item.SelectedAnswer === item.answer) {
                                            //             correct++;
                                            //         }
                                            //     });

                                            //     if (correct === selectedOptions.length) {
                                            //         setIsQuizSubmitted(true);
                                            //         // handleApplyTaskClick();
                                            //         submitform()
                                            //     } else {
                                            //         // handleOpenQuiz(
                                            //         //     selecetedAllocation?.venueId?.clientEntityId?.clientEntityId
                                            //         // );
                                            //         setQuizResult({
                                            //             passed: false,
                                            //             correct,
                                            //             total: selectedOptions.length
                                            //         });
                                            //     }
                                            // }}
                                            onClick={() => {
                                                let correct = 0;
                                                const wrongQuestions: any[] = [];
                                                const wrongSelectedOptions: any[] = [];

                                                // displayQuizList.forEach((question: any, index: number) => {
                                                //     const answer = selectedOptions[index];

                                                //     if (answer.SelectedAnswer === answer.answer) {
                                                //         correct++;
                                                //     } else {
                                                //         wrongQuestions.push(question);
                                                //         wrongSelectedOptions.push({
                                                //             ...answer,
                                                //             SelectedAnswer: null // reset answer
                                                //         });
                                                //     }
                                                // });
                                                displayQuizList.forEach((question: any, index: number) => {
                                                    const answer = selectedOptions[index];

                                                    // Correct answers from API
                                                    const correctAnswers = question.answerIds
                                                        .split(",")
                                                        .map((id: string) => Number(id.trim()))
                                                        .sort((a: number, b: number) => a - b);

                                                    let isCorrect = false;

                                                    if (question.questionType === "radio") {
                                                        // Single answer
                                                        isCorrect =
                                                            Number(answer?.SelectedAnswer) === correctAnswers[0];
                                                    } else if (question.questionType === "checkbox") {
                                                        // Multiple answers
                                                        const selected = [...(answer?.SelectedAnswer || [])].sort(
                                                            (a: number, b: number) => a - b
                                                        );

                                                        isCorrect =
                                                            selected.length === correctAnswers.length &&
                                                            selected.every(
                                                                (value: number, i: number) => value === correctAnswers[i]
                                                            );
                                                    }

                                                    if (isCorrect) {
                                                        correct++;
                                                    } else {
                                                        wrongQuestions.push(question);
                                                        wrongSelectedOptions.push({
                                                            ...answer,
                                                            SelectedAnswer:
                                                                question.questionType === "checkbox" ? [] : null,
                                                        });
                                                    }
                                                });


                                                if (wrongQuestions.length === 0) {
                                                    setIsQuizSubmitted(true);
                                                    submitform();

                                                } else {
                                                    setRetryQuizList(wrongQuestions);
                                                    setSelectedOptions(wrongSelectedOptions);

                                                    setQuizResult({
                                                        passed: false,
                                                        correct,
                                                        total: displayQuizList.length,
                                                    });
                                                }
                                            }}
                                        >
                                            Submit Quiz
                                        </Button>
                                    )}
                                </>
                            )}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default ReadBrief;
